SmTextField = require './sm-text-field'

App.SmPrefilledInputComponent = SmTextField.extend
  prefilled: ''

  appendPrefilledText: (->
    if Em.isEmpty @get('value')
      @set('value', @get('prefilled'))

      Em.run.next =>
        l = @get('prefilled').length
        @$().get(0).setSelectionRange(l, l)
  ).on('focusIn')

  resetPrefilled: (->
    Em.run.next =>
      if @get('value') is @get('prefilled')
        @set('value', '')
  ).on('focusOut')

